import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

export default React.memo(props => (
  <SvgIcon {...props} width="17" height="16" viewBox="0 0 17 16" fill="none">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.33374 4.49996C3.33374 3.48744 4.15455 2.66663 5.16707 2.66663H9.33374C9.46635 2.66663 9.59353 2.7193 9.68729 2.81307L11.0206 4.14641C11.2159 4.34167 11.2159 4.65825 11.0206 4.85351C10.8254 5.04877 10.5088 5.04877 10.3135 4.85351L9.12663 3.66663H5.16707C4.70684 3.66663 4.33374 4.03972 4.33374 4.49996V11.5C4.33374 11.9602 4.70683 12.3333 5.16707 12.3333H10.8337C11.294 12.3333 11.6671 11.9602 11.6671 11.5V10.3333C11.6671 10.0572 11.8909 9.83329 12.1671 9.83329C12.4432 9.83329 12.6671 10.0572 12.6671 10.3333V11.5C12.6671 12.5125 11.8463 13.3333 10.8337 13.3333H5.16707C4.15456 13.3333 3.33374 12.5125 3.33374 11.5V4.49996Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.33374 2.83329C9.60988 2.83329 9.83374 3.05715 9.83374 3.33329V5.33329C9.83374 5.60944 9.60988 5.83329 9.33374 5.83329C9.0576 5.83329 8.83374 5.60944 8.83374 5.33329V3.33329C8.83374 3.05715 9.0576 2.83329 9.33374 2.83329Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.6064 3.78754C12.9898 3.4041 13.6115 3.4041 13.995 3.78755L14.8795 4.67209C15.2629 5.05552 15.2629 5.67718 14.8795 6.06062L10.4018 10.5383C10.336 10.6041 10.2533 10.6502 10.1628 10.6715L8.11493 11.1533C7.94637 11.193 7.76929 11.1426 7.64685 11.0202C7.52441 10.8977 7.47404 10.7207 7.5137 10.5521L7.99554 8.50428C8.01684 8.41377 8.06295 8.33099 8.1287 8.26524L12.6064 3.78754C12.6064 3.78753 12.6064 3.78754 12.6064 3.78754ZM13.2878 4.49465C13.2878 4.49464 13.2878 4.49465 13.2878 4.49465V4.49465ZM13.3007 4.50749L14.1596 5.36636L9.79526 9.73065L8.67211 9.99492L8.93638 8.87177L13.3007 4.50749Z"
      fill="currentColor"
    />
  </SvgIcon>
));
